module.exports = __webpack_public_path__ + "img/close-expire-at-coupon-alert-icon.3e842a95.svg";